// GENERATED by scripts/generate-layout-css.mjs — do not edit.
// Source: scripts/layoutCss.input.css

export const LAYOUT_CSS_TAILWIND_VERSION = '4.3.3';

export const LAYOUT_CSS_SHA256 = 'ca47317fe66e21f91e3a94eb53874ccb3a6389787feca9002a674e0f4589cf40';

export const LAYOUT_CSS =
    '/*! tailwindcss v4.3.3 | MIT License | https://tailwindcss.com */\n@layer base{*,:before,:after{box-sizing:border-box}body{margin:0}}@layer theme{:root,:host{--spacing:.25rem;--container-xs:20rem;--container-sm:24rem;--container-md:28rem;--container-lg:32rem;--container-xl:36rem;--container-2xl:42rem;--container-3xl:48rem;--container-4xl:56rem;--container-5xl:64rem;--container-6xl:72rem;--container-7xl:80rem;--aspect-video:16 / 9}}@layer utilities{.absolute{position:absolute}.relative{position:relative}.static{position:static}.inset-0{inset:0}.inset-x-0{inset-inline:0}.inset-y-0{inset-block:0}.top-0{top:0}.right-0{right:0}.bottom-0{bottom:0}.left-0{left:0}.z-0{z-index:0}.z-10{z-index:10}.z-20{z-index:20}.z-30{z-index:30}.z-40{z-index:40}.z-50{z-index:50}.order-1{order:1}.order-2{order:2}.order-3{order:3}.order-4{order:4}.order-5{order:5}.order-6{order:6}.order-7{order:7}.order-8{order:8}.order-9{order:9}.order-10{order:10}.order-11{order:11}.order-12{order:12}.order-first{order:-9999}.order-last{order:9999}.order-none{order:0}.col-span-1{grid-column:span 1/span 1}.col-span-2{grid-column:span 2/span 2}.col-span-3{grid-column:span 3/span 3}.col-span-4{grid-column:span 4/span 4}.col-span-5{grid-column:span 5/span 5}.col-span-6{grid-column:span 6/span 6}.col-span-7{grid-column:span 7/span 7}.col-span-8{grid-column:span 8/span 8}.col-span-9{grid-column:span 9/span 9}.col-span-10{grid-column:span 10/span 10}.col-span-11{grid-column:span 11/span 11}.col-span-12{grid-column:span 12/span 12}.col-span-full{grid-column:1/-1}.col-start-1{grid-column-start:1}.col-start-2{grid-column-start:2}.col-start-3{grid-column-start:3}.col-start-4{grid-column-start:4}.col-start-5{grid-column-start:5}.col-start-6{grid-column-start:6}.col-start-7{grid-column-start:7}.col-start-8{grid-column-start:8}.col-start-9{grid-column-start:9}.col-start-10{grid-column-start:10}.col-start-11{grid-column-start:11}.col-start-12{grid-column-start:12}.col-start-13{grid-column-start:13}.col-start-auto{grid-column-start:auto}.col-end-1{grid-column-end:1}.col-end-2{grid-column-end:2}.col-end-3{grid-column-end:3}.col-end-4{grid-column-end:4}.col-end-5{grid-column-end:5}.col-end-6{grid-column-end:6}.col-end-7{grid-column-end:7}.col-end-8{grid-column-end:8}.col-end-9{grid-column-end:9}.col-end-10{grid-column-end:10}.col-end-11{grid-column-end:11}.col-end-12{grid-column-end:12}.col-end-13{grid-column-end:13}.col-end-auto{grid-column-end:auto}.row-span-1{grid-row:span 1/span 1}.row-span-2{grid-row:span 2/span 2}.row-span-3{grid-row:span 3/span 3}.row-span-4{grid-row:span 4/span 4}.row-span-5{grid-row:span 5/span 5}.row-span-6{grid-row:span 6/span 6}.row-span-7{grid-row:span 7/span 7}.row-span-8{grid-row:span 8/span 8}.row-span-9{grid-row:span 9/span 9}.row-span-10{grid-row:span 10/span 10}.row-span-11{grid-row:span 11/span 11}.row-span-12{grid-row:span 12/span 12}.row-span-full{grid-row:1/-1}.row-start-1{grid-row-start:1}.row-start-2{grid-row-start:2}.row-start-3{grid-row-start:3}.row-start-4{grid-row-start:4}.row-start-5{grid-row-start:5}.row-start-6{grid-row-start:6}.row-start-7{grid-row-start:7}.row-start-8{grid-row-start:8}.row-start-9{grid-row-start:9}.row-start-10{grid-row-start:10}.row-start-11{grid-row-start:11}.row-start-12{grid-row-start:12}.row-start-13{grid-row-start:13}.row-start-auto{grid-row-start:auto}.row-end-1{grid-row-end:1}.row-end-2{grid-row-end:2}.row-end-3{grid-row-end:3}.row-end-4{grid-row-end:4}.row-end-5{grid-row-end:5}.row-end-6{grid-row-end:6}.row-end-7{grid-row-end:7}.row-end-8{grid-row-end:8}.row-end-9{grid-row-end:9}.row-end-10{grid-row-end:10}.row-end-11{grid-row-end:11}.row-end-12{grid-row-end:12}.row-end-13{grid-row-end:13}.row-end-auto{grid-row-end:auto}.m-0{margin:0}.m-0\\.5{margin:calc(var(--spacing) * .5)}.m-1{margin:var(--spacing)}.m-1\\.5{margin:calc(var(--spacing) * 1.5)}.m-2{margin:calc(var(--spacing) * 2)}.m-2\\.5{margin:calc(var(--spacing) * 2.5)}.m-3{margin:calc(var(--spacing) * 3)}.m-3\\.5{margin:calc(var(--spacing) * 3.5)}.m-4{margin:calc(var(--spacing) * 4)}.m-5{margin:calc(var(--spacing) * 5)}.m-6{margin:calc(var(--spacing) * 6)}.m-7{margin:calc(var(--spacing) * 7)}.m-8{margin:calc(var(--spacing) * 8)}.m-9{margin:calc(var(--spacing) * 9)}.m-10{margin:calc(var(--spacing) * 10)}.m-11{margin:calc(var(--spacing) * 11)}.m-12{margin:calc(var(--spacing) * 12)}.m-14{margin:calc(var(--spacing) * 14)}.m-16{margin:calc(var(--spacing) * 16)}.m-20{margin:calc(var(--spacing) * 20)}.m-24{margin:calc(var(--spacing) * 24)}.m-28{margin:calc(var(--spacing) * 28)}.m-32{margin:calc(var(--spacing) * 32)}.m-36{margin:calc(var(--spacing) * 36)}.m-40{margin:calc(var(--spacing) * 40)}.m-44{margin:calc(var(--spacing) * 44)}.m-48{margin:calc(var(--spacing) * 48)}.m-52{margin:calc(var(--spacing) * 52)}.m-56{margin:calc(var(--spacing) * 56)}.m-60{margin:calc(var(--spacing) * 60)}.m-64{margin:calc(var(--spacing) * 64)}.m-72{margin:calc(var(--spacing) * 72)}.m-80{margin:calc(var(--spacing) * 80)}.m-96{margin:calc(var(--spacing) * 96)}.m-auto{margin:auto}.mx-0{margin-inline:0}.mx-0\\.5{margin-inline:calc(var(--spacing) * .5)}.mx-1{margin-inline:var(--spacing)}.mx-1\\.5{margin-inline:calc(var(--spacing) * 1.5)}.mx-2{margin-inline:calc(var(--spacing) * 2)}.mx-2\\.5{margin-inline:calc(var(--spacing) * 2.5)}.mx-3{margin-inline:calc(var(--spacing) * 3)}.mx-3\\.5{margin-inline:calc(var(--spacing) * 3.5)}.mx-4{margin-inline:calc(var(--spacing) * 4)}.mx-5{margin-inline:calc(var(--spacing) * 5)}.mx-6{margin-inline:calc(var(--spacing) * 6)}.mx-7{margin-inline:calc(var(--spacing) * 7)}.mx-8{margin-inline:calc(var(--spacing) * 8)}.mx-9{margin-inline:calc(var(--spacing) * 9)}.mx-10{margin-inline:calc(var(--spacing) * 10)}.mx-11{margin-inline:calc(var(--spacing) * 11)}.mx-12{margin-inline:calc(var(--spacing) * 12)}.mx-14{margin-inline:calc(var(--spacing) * 14)}.mx-16{margin-inline:calc(var(--spacing) * 16)}.mx-20{margin-inline:calc(var(--spacing) * 20)}.mx-24{margin-inline:calc(var(--spacing) * 24)}.mx-28{margin-inline:calc(var(--spacing) * 28)}.mx-32{margin-inline:calc(var(--spacing) * 32)}.mx-36{margin-inline:calc(var(--spacing) * 36)}.mx-40{margin-inline:calc(var(--spacing) * 40)}.mx-44{margin-inline:calc(var(--spacing) * 44)}.mx-48{margin-inline:calc(var(--spacing) * 48)}.mx-52{margin-inline:calc(var(--spacing) * 52)}.mx-56{margin-inline:calc(var(--spacing) * 56)}.mx-60{margin-inline:calc(var(--spacing) * 60)}.mx-64{margin-inline:calc(var(--spacing) * 64)}.mx-72{margin-inline:calc(var(--spacing) * 72)}.mx-80{margin-inline:calc(var(--spacing) * 80)}.mx-96{margin-inline:calc(var(--spacing) * 96)}.mx-auto{margin-inline:auto}.my-0{margin-block:0}.my-0\\.5{margin-block:calc(var(--spacing) * .5)}.my-1{margin-block:var(--spacing)}.my-1\\.5{margin-block:calc(var(--spacing) * 1.5)}.my-2{margin-block:calc(var(--spacing) * 2)}.my-2\\.5{margin-block:calc(var(--spacing) * 2.5)}.my-3{margin-block:calc(var(--spacing) * 3)}.my-3\\.5{margin-block:calc(var(--spacing) * 3.5)}.my-4{margin-block:calc(var(--spacing) * 4)}.my-5{margin-block:calc(var(--spacing) * 5)}.my-6{margin-block:calc(var(--spacing) * 6)}.my-7{margin-block:calc(var(--spacing) * 7)}.my-8{margin-block:calc(var(--spacing) * 8)}.my-9{margin-block:calc(var(--spacing) * 9)}.my-10{margin-block:calc(var(--spacing) * 10)}.my-11{margin-block:calc(var(--spacing) * 11)}.my-12{margin-block:calc(var(--spacing) * 12)}.my-14{margin-block:calc(var(--spacing) * 14)}.my-16{margin-block:calc(var(--spacing) * 16)}.my-20{margin-block:calc(var(--spacing) * 20)}.my-24{margin-block:calc(var(--spacing) * 24)}.my-28{margin-block:calc(var(--spacing) * 28)}.my-32{margin-block:calc(var(--spacing) * 32)}.my-36{margin-block:calc(var(--spacing) * 36)}.my-40{margin-block:calc(var(--spacing) * 40)}.my-44{margin-block:calc(var(--spacing) * 44)}.my-48{margin-block:calc(var(--spacing) * 48)}.my-52{margin-block:calc(var(--spacing) * 52)}.my-56{margin-block:calc(var(--spacing) * 56)}.my-60{margin-block:calc(var(--spacing) * 60)}.my-64{margin-block:calc(var(--spacing) * 64)}.my-72{margin-block:calc(var(--spacing) * 72)}.my-80{margin-block:calc(var(--spacing) * 80)}.my-96{margin-block:calc(var(--spacing) * 96)}.my-auto{margin-block:auto}.mt-0{margin-top:0}.mt-0\\.5{margin-top:calc(var(--spacing) * .5)}.mt-1{margin-top:var(--spacing)}.mt-1\\.5{margin-top:calc(var(--spacing) * 1.5)}.mt-2{margin-top:calc(var(--spacing) * 2)}.mt-2\\.5{margin-top:calc(var(--spacing) * 2.5)}.mt-3{margin-top:calc(var(--spacing) * 3)}.mt-3\\.5{margin-top:calc(var(--spacing) * 3.5)}.mt-4{margin-top:calc(var(--spacing) * 4)}.mt-5{margin-top:calc(var(--spacing) * 5)}.mt-6{margin-top:calc(var(--spacing) * 6)}.mt-7{margin-top:calc(var(--spacing) * 7)}.mt-8{margin-top:calc(var(--spacing) * 8)}.mt-9{margin-top:calc(var(--spacing) * 9)}.mt-10{margin-top:calc(var(--spacing) * 10)}.mt-11{margin-top:calc(var(--spacing) * 11)}.mt-12{margin-top:calc(var(--spacing) * 12)}.mt-14{margin-top:calc(var(--spacing) * 14)}.mt-16{margin-top:calc(var(--spacing) * 16)}.mt-20{margin-top:calc(var(--spacing) * 20)}.mt-24{margin-top:calc(var(--spacing) * 24)}.mt-28{margin-top:calc(var(--spacing) * 28)}.mt-32{margin-top:calc(var(--spacing) * 32)}.mt-36{margin-top:calc(var(--spacing) * 36)}.mt-40{margin-top:calc(var(--spacing) * 40)}.mt-44{margin-top:calc(var(--spacing) * 44)}.mt-48{margin-top:calc(var(--spacing) * 48)}.mt-52{margin-top:calc(var(--spacing) * 52)}.mt-56{margin-top:calc(var(--spacing) * 56)}.mt-60{margin-top:calc(var(--spacing) * 60)}.mt-64{margin-top:calc(var(--spacing) * 64)}.mt-72{margin-top:calc(var(--spacing) * 72)}.mt-80{margin-top:calc(var(--spacing) * 80)}.mt-96{margin-top:calc(var(--spacing) * 96)}.mt-auto{margin-top:auto}.mr-0{margin-right:0}.mr-0\\.5{margin-right:calc(var(--spacing) * .5)}.mr-1{margin-right:var(--spacing)}.mr-1\\.5{margin-right:calc(var(--spacing) * 1.5)}.mr-2{margin-right:calc(var(--spacing) * 2)}.mr-2\\.5{margin-right:calc(var(--spacing) * 2.5)}.mr-3{margin-right:calc(var(--spacing) * 3)}.mr-3\\.5{margin-right:calc(var(--spacing) * 3.5)}.mr-4{margin-right:calc(var(--spacing) * 4)}.mr-5{margin-right:calc(var(--spacing) * 5)}.mr-6{margin-right:calc(var(--spacing) * 6)}.mr-7{margin-right:calc(var(--spacing) * 7)}.mr-8{margin-right:calc(var(--spacing) * 8)}.mr-9{margin-right:calc(var(--spacing) * 9)}.mr-10{margin-right:calc(var(--spacing) * 10)}.mr-11{margin-right:calc(var(--spacing) * 11)}.mr-12{margin-right:calc(var(--spacing) * 12)}.mr-14{margin-right:calc(var(--spacing) * 14)}.mr-16{margin-right:calc(var(--spacing) * 16)}.mr-20{margin-right:calc(var(--spacing) * 20)}.mr-24{margin-right:calc(var(--spacing) * 24)}.mr-28{margin-right:calc(var(--spacing) * 28)}.mr-32{margin-right:calc(var(--spacing) * 32)}.mr-36{margin-right:calc(var(--spacing) * 36)}.mr-40{margin-right:calc(var(--spacing) * 40)}.mr-44{margin-right:calc(var(--spacing) * 44)}.mr-48{margin-right:calc(var(--spacing) * 48)}.mr-52{margin-right:calc(var(--spacing) * 52)}.mr-56{margin-right:calc(var(--spacing) * 56)}.mr-60{margin-right:calc(var(--spacing) * 60)}.mr-64{margin-right:calc(var(--spacing) * 64)}.mr-72{margin-right:calc(var(--spacing) * 72)}.mr-80{margin-right:calc(var(--spacing) * 80)}.mr-96{margin-right:calc(var(--spacing) * 96)}.mr-auto{margin-right:auto}.mb-0{margin-bottom:0}.mb-0\\.5{margin-bottom:calc(var(--spacing) * .5)}.mb-1{margin-bottom:var(--spacing)}.mb-1\\.5{margin-bottom:calc(var(--spacing) * 1.5)}.mb-2{margin-bottom:calc(var(--spacing) * 2)}.mb-2\\.5{margin-bottom:calc(var(--spacing) * 2.5)}.mb-3{margin-bottom:calc(var(--spacing) * 3)}.mb-3\\.5{margin-bottom:calc(var(--spacing) * 3.5)}.mb-4{margin-bottom:calc(var(--spacing) * 4)}.mb-5{margin-bottom:calc(var(--spacing) * 5)}.mb-6{margin-bottom:calc(var(--spacing) * 6)}.mb-7{margin-bottom:calc(var(--spacing) * 7)}.mb-8{margin-bottom:calc(var(--spacing) * 8)}.mb-9{margin-bottom:calc(var(--spacing) * 9)}.mb-10{margin-bottom:calc(var(--spacing) * 10)}.mb-11{margin-bottom:calc(var(--spacing) * 11)}.mb-12{margin-bottom:calc(var(--spacing) * 12)}.mb-14{margin-bottom:calc(var(--spacing) * 14)}.mb-16{margin-bottom:calc(var(--spacing) * 16)}.mb-20{margin-bottom:calc(var(--spacing) * 20)}.mb-24{margin-bottom:calc(var(--spacing) * 24)}.mb-28{margin-bottom:calc(var(--spacing) * 28)}.mb-32{margin-bottom:calc(var(--spacing) * 32)}.mb-36{margin-bottom:calc(var(--spacing) * 36)}.mb-40{margin-bottom:calc(var(--spacing) * 40)}.mb-44{margin-bottom:calc(var(--spacing) * 44)}.mb-48{margin-bottom:calc(var(--spacing) * 48)}.mb-52{margin-bottom:calc(var(--spacing) * 52)}.mb-56{margin-bottom:calc(var(--spacing) * 56)}.mb-60{margin-bottom:calc(var(--spacing) * 60)}.mb-64{margin-bottom:calc(var(--spacing) * 64)}.mb-72{margin-bottom:calc(var(--spacing) * 72)}.mb-80{margin-bottom:calc(var(--spacing) * 80)}.mb-96{margin-bottom:calc(var(--spacing) * 96)}.mb-auto{margin-bottom:auto}.ml-0{margin-left:0}.ml-0\\.5{margin-left:calc(var(--spacing) * .5)}.ml-1{margin-left:var(--spacing)}.ml-1\\.5{margin-left:calc(var(--spacing) * 1.5)}.ml-2{margin-left:calc(var(--spacing) * 2)}.ml-2\\.5{margin-left:calc(var(--spacing) * 2.5)}.ml-3{margin-left:calc(var(--spacing) * 3)}.ml-3\\.5{margin-left:calc(var(--spacing) * 3.5)}.ml-4{margin-left:calc(var(--spacing) * 4)}.ml-5{margin-left:calc(var(--spacing) * 5)}.ml-6{margin-left:calc(var(--spacing) * 6)}.ml-7{margin-left:calc(var(--spacing) * 7)}.ml-8{margin-left:calc(var(--spacing) * 8)}.ml-9{margin-left:calc(var(--spacing) * 9)}.ml-10{margin-left:calc(var(--spacing) * 10)}.ml-11{margin-left:calc(var(--spacing) * 11)}.ml-12{margin-left:calc(var(--spacing) * 12)}.ml-14{margin-left:calc(var(--spacing) * 14)}.ml-16{margin-left:calc(var(--spacing) * 16)}.ml-20{margin-left:calc(var(--spacing) * 20)}.ml-24{margin-left:calc(var(--spacing) * 24)}.ml-28{margin-left:calc(var(--spacing) * 28)}.ml-32{margin-left:calc(var(--spacing) * 32)}.ml-36{margin-left:calc(var(--spacing) * 36)}.ml-40{margin-left:calc(var(--spacing) * 40)}.ml-44{margin-left:calc(var(--spacing) * 44)}.ml-48{margin-left:calc(var(--spacing) * 48)}.ml-52{margin-left:calc(var(--spacing) * 52)}.ml-56{margin-left:calc(var(--spacing) * 56)}.ml-60{margin-left:calc(var(--spacing) * 60)}.ml-64{margin-left:calc(var(--spacing) * 64)}.ml-72{margin-left:calc(var(--spacing) * 72)}.ml-80{margin-left:calc(var(--spacing) * 80)}.ml-96{margin-left:calc(var(--spacing) * 96)}.ml-auto{margin-left:auto}.box-border{box-sizing:border-box}.box-content{box-sizing:content-box}.block{display:block}.contents{display:contents}.flex{display:flex}.grid{display:grid}.hidden{display:none}.inline{display:inline}.inline-block{display:inline-block}.inline-flex{display:inline-flex}.inline-grid{display:inline-grid}.aspect-auto{aspect-ratio:auto}.aspect-square{aspect-ratio:1}.aspect-video{aspect-ratio:var(--aspect-video)}.size-full{width:100%;height:100%}.h-0{height:0}.h-1{height:var(--spacing)}.h-1\\/2{height:50%}.h-2{height:calc(var(--spacing) * 2)}.h-3{height:calc(var(--spacing) * 3)}.h-4{height:calc(var(--spacing) * 4)}.h-5{height:calc(var(--spacing) * 5)}.h-6{height:calc(var(--spacing) * 6)}.h-8{height:calc(var(--spacing) * 8)}.h-10{height:calc(var(--spacing) * 10)}.h-12{height:calc(var(--spacing) * 12)}.h-16{height:calc(var(--spacing) * 16)}.h-20{height:calc(var(--spacing) * 20)}.h-24{height:calc(var(--spacing) * 24)}.h-28{height:calc(var(--spacing) * 28)}.h-32{height:calc(var(--spacing) * 32)}.h-36{height:calc(var(--spacing) * 36)}.h-40{height:calc(var(--spacing) * 40)}.h-44{height:calc(var(--spacing) * 44)}.h-48{height:calc(var(--spacing) * 48)}.h-56{height:calc(var(--spacing) * 56)}.h-64{height:calc(var(--spacing) * 64)}.h-72{height:calc(var(--spacing) * 72)}.h-80{height:calc(var(--spacing) * 80)}.h-96{height:calc(var(--spacing) * 96)}.h-auto{height:auto}.h-fit{height:fit-content}.h-full{height:100%}.h-max{height:max-content}.h-min{height:min-content}.h-px{height:1px}.h-screen{height:100vh}.max-h-full{max-height:100%}.min-h-0{min-height:0}.min-h-full{min-height:100%}.w-0{width:0}.w-1{width:var(--spacing)}.w-1\\/2{width:50%}.w-1\\/12{width:8.33333%}.w-2{width:calc(var(--spacing) * 2)}.w-2\\/12{width:16.6667%}.w-3{width:calc(var(--spacing) * 3)}.w-3\\/12{width:25%}.w-4{width:calc(var(--spacing) * 4)}.w-4\\/12{width:33.3333%}.w-5{width:calc(var(--spacing) * 5)}.w-5\\/12{width:41.6667%}.w-6{width:calc(var(--spacing) * 6)}.w-6\\/12{width:50%}.w-7\\/12{width:58.3333%}.w-8{width:calc(var(--spacing) * 8)}.w-8\\/12{width:66.6667%}.w-9\\/12{width:75%}.w-10{width:calc(var(--spacing) * 10)}.w-10\\/12{width:83.3333%}.w-11\\/12{width:91.6667%}.w-12{width:calc(var(--spacing) * 12)}.w-16{width:calc(var(--spacing) * 16)}.w-20{width:calc(var(--spacing) * 20)}.w-24{width:calc(var(--spacing) * 24)}.w-28{width:calc(var(--spacing) * 28)}.w-32{width:calc(var(--spacing) * 32)}.w-36{width:calc(var(--spacing) * 36)}.w-40{width:calc(var(--spacing) * 40)}.w-44{width:calc(var(--spacing) * 44)}.w-48{width:calc(var(--spacing) * 48)}.w-56{width:calc(var(--spacing) * 56)}.w-64{width:calc(var(--spacing) * 64)}.w-72{width:calc(var(--spacing) * 72)}.w-80{width:calc(var(--spacing) * 80)}.w-96{width:calc(var(--spacing) * 96)}.w-auto{width:auto}.w-fit{width:fit-content}.w-full{width:100%}.w-max{width:max-content}.w-min{width:min-content}.w-px{width:1px}.w-screen{width:100vw}.max-w-2xl{max-width:var(--container-2xl)}.max-w-3xl{max-width:var(--container-3xl)}.max-w-4xl{max-width:var(--container-4xl)}.max-w-5xl{max-width:var(--container-5xl)}.max-w-6xl{max-width:var(--container-6xl)}.max-w-7xl{max-width:var(--container-7xl)}.max-w-fit{max-width:fit-content}.max-w-full{max-width:100%}.max-w-lg{max-width:var(--container-lg)}.max-w-max{max-width:max-content}.max-w-md{max-width:var(--container-md)}.max-w-min{max-width:min-content}.max-w-none{max-width:none}.max-w-sm{max-width:var(--container-sm)}.max-w-xl{max-width:var(--container-xl)}.max-w-xs{max-width:var(--container-xs)}.min-w-0{min-width:0}.min-w-full{min-width:100%}.flex-1{flex:1}.flex-auto{flex:auto}.flex-initial{flex:0 auto}.flex-none{flex:none}.shrink{flex-shrink:1}.shrink-0{flex-shrink:0}.grow{flex-grow:1}.grow-0{flex-grow:0}.basis-0{flex-basis:0}.basis-1\\/2{flex-basis:50%}.basis-1\\/3{flex-basis:33.3333%}.basis-1\\/4{flex-basis:25%}.basis-2\\/3{flex-basis:66.6667%}.basis-3\\/4{flex-basis:75%}.basis-auto{flex-basis:auto}.basis-full{flex-basis:100%}.auto-cols-auto{grid-auto-columns:auto}.auto-cols-fr{grid-auto-columns:minmax(0,1fr)}.auto-cols-max{grid-auto-columns:max-content}.auto-cols-min{grid-auto-columns:min-content}.grid-flow-col{grid-auto-flow:column}.grid-flow-col-dense{grid-auto-flow:column dense}.grid-flow-dense{grid-auto-flow:dense}.grid-flow-row{grid-auto-flow:row}.grid-flow-row-dense{grid-auto-flow:dense}.auto-rows-auto{grid-auto-rows:auto}.auto-rows-fr{grid-auto-rows:minmax(0,1fr)}.auto-rows-max{grid-auto-rows:max-content}.auto-rows-min{grid-auto-rows:min-content}.grid-cols-1{grid-template-columns:repeat(1,minmax(0,1fr))}.grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}.grid-cols-3{grid-template-columns:repeat(3,minmax(0,1fr))}.grid-cols-4{grid-template-columns:repeat(4,minmax(0,1fr))}.grid-cols-5{grid-template-columns:repeat(5,minmax(0,1fr))}.grid-cols-6{grid-template-columns:repeat(6,minmax(0,1fr))}.grid-cols-7{grid-template-columns:repeat(7,minmax(0,1fr))}.grid-cols-8{grid-template-columns:repeat(8,minmax(0,1fr))}.grid-cols-9{grid-template-columns:repeat(9,minmax(0,1fr))}.grid-cols-10{grid-template-columns:repeat(10,minmax(0,1fr))}.grid-cols-11{grid-template-columns:repeat(11,minmax(0,1fr))}.grid-cols-12{grid-template-columns:repeat(12,minmax(0,1fr))}.grid-cols-none{grid-template-columns:none}.grid-rows-1{grid-template-rows:repeat(1,minmax(0,1fr))}.grid-rows-2{grid-template-rows:repeat(2,minmax(0,1fr))}.grid-rows-3{grid-template-rows:repeat(3,minmax(0,1fr))}.grid-rows-4{grid-template-rows:repeat(4,minmax(0,1fr))}.grid-rows-5{grid-template-rows:repeat(5,minmax(0,1fr))}.grid-rows-6{grid-template-rows:repeat(6,minmax(0,1fr))}.grid-rows-none{grid-template-rows:none}.flex-col{flex-direction:column}.flex-col-reverse{flex-direction:column-reverse}.flex-row{flex-direction:row}.flex-row-reverse{flex-direction:row-reverse}.flex-nowrap{flex-wrap:nowrap}.flex-wrap{flex-wrap:wrap}.flex-wrap-reverse{flex-wrap:wrap-reverse}.place-content-center{place-content:center}.place-content-end{place-content:end}.place-content-start{place-content:start}.place-content-stretch{place-content:stretch}.place-items-center{place-items:center}.place-items-end{place-items:end}.place-items-start{place-items:start}.place-items-stretch{place-items:stretch stretch}.content-around{align-content:space-around}.content-between{align-content:space-between}.content-center{align-content:center}.content-end{align-content:flex-end}.content-evenly{align-content:space-evenly}.content-normal{align-content:normal}.content-start{align-content:flex-start}.content-stretch{align-content:stretch}.items-baseline{align-items:baseline}.items-center{align-items:center}.items-end{align-items:flex-end}.items-start{align-items:flex-start}.items-stretch{align-items:stretch}.justify-around{justify-content:space-around}.justify-between{justify-content:space-between}.justify-center{justify-content:center}.justify-end{justify-content:flex-end}.justify-evenly{justify-content:space-evenly}.justify-start{justify-content:flex-start}.justify-stretch{justify-content:stretch}.justify-items-center{justify-items:center}.justify-items-end{justify-items:end}.justify-items-start{justify-items:start}.justify-items-stretch{justify-items:stretch}.gap-0{gap:0}.gap-0\\.5{gap:calc(var(--spacing) * .5)}.gap-1{gap:var(--spacing)}.gap-1\\.5{gap:calc(var(--spacing) * 1.5)}.gap-2{gap:calc(var(--spacing) * 2)}.gap-2\\.5{gap:calc(var(--spacing) * 2.5)}.gap-3{gap:calc(var(--spacing) * 3)}.gap-3\\.5{gap:calc(var(--spacing) * 3.5)}.gap-4{gap:calc(var(--spacing) * 4)}.gap-5{gap:calc(var(--spacing) * 5)}.gap-6{gap:calc(var(--spacing) * 6)}.gap-7{gap:calc(var(--spacing) * 7)}.gap-8{gap:calc(var(--spacing) * 8)}.gap-9{gap:calc(var(--spacing) * 9)}.gap-10{gap:calc(var(--spacing) * 10)}.gap-11{gap:calc(var(--spacing) * 11)}.gap-12{gap:calc(var(--spacing) * 12)}.gap-14{gap:calc(var(--spacing) * 14)}.gap-16{gap:calc(var(--spacing) * 16)}.gap-20{gap:calc(var(--spacing) * 20)}.gap-24{gap:calc(var(--spacing) * 24)}.gap-28{gap:calc(var(--spacing) * 28)}.gap-32{gap:calc(var(--spacing) * 32)}.gap-36{gap:calc(var(--spacing) * 36)}.gap-40{gap:calc(var(--spacing) * 40)}.gap-44{gap:calc(var(--spacing) * 44)}.gap-48{gap:calc(var(--spacing) * 48)}.gap-52{gap:calc(var(--spacing) * 52)}.gap-56{gap:calc(var(--spacing) * 56)}.gap-60{gap:calc(var(--spacing) * 60)}.gap-64{gap:calc(var(--spacing) * 64)}.gap-72{gap:calc(var(--spacing) * 72)}.gap-80{gap:calc(var(--spacing) * 80)}.gap-96{gap:calc(var(--spacing) * 96)}.gap-x-0{column-gap:0}.gap-x-0\\.5{column-gap:calc(var(--spacing) * .5)}.gap-x-1{column-gap:var(--spacing)}.gap-x-1\\.5{column-gap:calc(var(--spacing) * 1.5)}.gap-x-2{column-gap:calc(var(--spacing) * 2)}.gap-x-2\\.5{column-gap:calc(var(--spacing) * 2.5)}.gap-x-3{column-gap:calc(var(--spacing) * 3)}.gap-x-3\\.5{column-gap:calc(var(--spacing) * 3.5)}.gap-x-4{column-gap:calc(var(--spacing) * 4)}.gap-x-5{column-gap:calc(var(--spacing) * 5)}.gap-x-6{column-gap:calc(var(--spacing) * 6)}.gap-x-7{column-gap:calc(var(--spacing) * 7)}.gap-x-8{column-gap:calc(var(--spacing) * 8)}.gap-x-9{column-gap:calc(var(--spacing) * 9)}.gap-x-10{column-gap:calc(var(--spacing) * 10)}.gap-x-11{column-gap:calc(var(--spacing) * 11)}.gap-x-12{column-gap:calc(var(--spacing) * 12)}.gap-x-14{column-gap:calc(var(--spacing) * 14)}.gap-x-16{column-gap:calc(var(--spacing) * 16)}.gap-x-20{column-gap:calc(var(--spacing) * 20)}.gap-x-24{column-gap:calc(var(--spacing) * 24)}.gap-x-28{column-gap:calc(var(--spacing) * 28)}.gap-x-32{column-gap:calc(var(--spacing) * 32)}.gap-x-36{column-gap:calc(var(--spacing) * 36)}.gap-x-40{column-gap:calc(var(--spacing) * 40)}.gap-x-44{column-gap:calc(var(--spacing) * 44)}.gap-x-48{column-gap:calc(var(--spacing) * 48)}.gap-x-52{column-gap:calc(var(--spacing) * 52)}.gap-x-56{column-gap:calc(var(--spacing) * 56)}.gap-x-60{column-gap:calc(var(--spacing) * 60)}.gap-x-64{column-gap:calc(var(--spacing) * 64)}.gap-x-72{column-gap:calc(var(--spacing) * 72)}.gap-x-80{column-gap:calc(var(--spacing) * 80)}.gap-x-96{column-gap:calc(var(--spacing) * 96)}.gap-y-0{row-gap:0}.gap-y-0\\.5{row-gap:calc(var(--spacing) * .5)}.gap-y-1{row-gap:var(--spacing)}.gap-y-1\\.5{row-gap:calc(var(--spacing) * 1.5)}.gap-y-2{row-gap:calc(var(--spacing) * 2)}.gap-y-2\\.5{row-gap:calc(var(--spacing) * 2.5)}.gap-y-3{row-gap:calc(var(--spacing) * 3)}.gap-y-3\\.5{row-gap:calc(var(--spacing) * 3.5)}.gap-y-4{row-gap:calc(var(--spacing) * 4)}.gap-y-5{row-gap:calc(var(--spacing) * 5)}.gap-y-6{row-gap:calc(var(--spacing) * 6)}.gap-y-7{row-gap:calc(var(--spacing) * 7)}.gap-y-8{row-gap:calc(var(--spacing) * 8)}.gap-y-9{row-gap:calc(var(--spacing) * 9)}.gap-y-10{row-gap:calc(var(--spacing) * 10)}.gap-y-11{row-gap:calc(var(--spacing) * 11)}.gap-y-12{row-gap:calc(var(--spacing) * 12)}.gap-y-14{row-gap:calc(var(--spacing) * 14)}.gap-y-16{row-gap:calc(var(--spacing) * 16)}.gap-y-20{row-gap:calc(var(--spacing) * 20)}.gap-y-24{row-gap:calc(var(--spacing) * 24)}.gap-y-28{row-gap:calc(var(--spacing) * 28)}.gap-y-32{row-gap:calc(var(--spacing) * 32)}.gap-y-36{row-gap:calc(var(--spacing) * 36)}.gap-y-40{row-gap:calc(var(--spacing) * 40)}.gap-y-44{row-gap:calc(var(--spacing) * 44)}.gap-y-48{row-gap:calc(var(--spacing) * 48)}.gap-y-52{row-gap:calc(var(--spacing) * 52)}.gap-y-56{row-gap:calc(var(--spacing) * 56)}.gap-y-60{row-gap:calc(var(--spacing) * 60)}.gap-y-64{row-gap:calc(var(--spacing) * 64)}.gap-y-72{row-gap:calc(var(--spacing) * 72)}.gap-y-80{row-gap:calc(var(--spacing) * 80)}.gap-y-96{row-gap:calc(var(--spacing) * 96)}.place-self-center{place-self:center}.place-self-end{place-self:end}.place-self-start{place-self:start}.place-self-stretch{place-self:stretch stretch}.self-auto{align-self:auto}.self-baseline{align-self:baseline}.self-center{align-self:center}.self-end{align-self:flex-end}.self-start{align-self:flex-start}.self-stretch{align-self:stretch}.justify-self-auto{justify-self:auto}.justify-self-center{justify-self:center}.justify-self-end{justify-self:flex-end}.justify-self-start{justify-self:flex-start}.justify-self-stretch{justify-self:stretch}.truncate{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.overflow-auto{overflow:auto}.overflow-clip{overflow:clip}.overflow-hidden{overflow:hidden}.overflow-visible{overflow:visible}.overflow-x-auto{overflow-x:auto}.overflow-x-clip{overflow-x:clip}.overflow-x-hidden{overflow-x:hidden}.overflow-x-visible{overflow-x:visible}.overflow-y-auto{overflow-y:auto}.overflow-y-clip{overflow-y:clip}.overflow-y-hidden{overflow-y:hidden}.overflow-y-visible{overflow-y:visible}.object-contain{object-fit:contain}.object-cover{object-fit:cover}.object-fill{object-fit:fill}.object-none{object-fit:none}.object-scale-down{object-fit:scale-down}.object-bottom{object-position:bottom}.object-center{object-position:center}.object-left{object-position:left}.object-right{object-position:right}.object-top{object-position:top}.p-0{padding:0}.p-0\\.5{padding:calc(var(--spacing) * .5)}.p-1{padding:var(--spacing)}.p-1\\.5{padding:calc(var(--spacing) * 1.5)}.p-2{padding:calc(var(--spacing) * 2)}.p-2\\.5{padding:calc(var(--spacing) * 2.5)}.p-3{padding:calc(var(--spacing) * 3)}.p-3\\.5{padding:calc(var(--spacing) * 3.5)}.p-4{padding:calc(var(--spacing) * 4)}.p-5{padding:calc(var(--spacing) * 5)}.p-6{padding:calc(var(--spacing) * 6)}.p-7{padding:calc(var(--spacing) * 7)}.p-8{padding:calc(var(--spacing) * 8)}.p-9{padding:calc(var(--spacing) * 9)}.p-10{padding:calc(var(--spacing) * 10)}.p-11{padding:calc(var(--spacing) * 11)}.p-12{padding:calc(var(--spacing) * 12)}.p-14{padding:calc(var(--spacing) * 14)}.p-16{padding:calc(var(--spacing) * 16)}.p-20{padding:calc(var(--spacing) * 20)}.p-24{padding:calc(var(--spacing) * 24)}.p-28{padding:calc(var(--spacing) * 28)}.p-32{padding:calc(var(--spacing) * 32)}.p-36{padding:calc(var(--spacing) * 36)}.p-40{padding:calc(var(--spacing) * 40)}.p-44{padding:calc(var(--spacing) * 44)}.p-48{padding:calc(var(--spacing) * 48)}.p-52{padding:calc(var(--spacing) * 52)}.p-56{padding:calc(var(--spacing) * 56)}.p-60{padding:calc(var(--spacing) * 60)}.p-64{padding:calc(var(--spacing) * 64)}.p-72{padding:calc(var(--spacing) * 72)}.p-80{padding:calc(var(--spacing) * 80)}.p-96{padding:calc(var(--spacing) * 96)}.px-0{padding-inline:0}.px-0\\.5{padding-inline:calc(var(--spacing) * .5)}.px-1{padding-inline:var(--spacing)}.px-1\\.5{padding-inline:calc(var(--spacing) * 1.5)}.px-2{padding-inline:calc(var(--spacing) * 2)}.px-2\\.5{padding-inline:calc(var(--spacing) * 2.5)}.px-3{padding-inline:calc(var(--spacing) * 3)}.px-3\\.5{padding-inline:calc(var(--spacing) * 3.5)}.px-4{padding-inline:calc(var(--spacing) * 4)}.px-5{padding-inline:calc(var(--spacing) * 5)}.px-6{padding-inline:calc(var(--spacing) * 6)}.px-7{padding-inline:calc(var(--spacing) * 7)}.px-8{padding-inline:calc(var(--spacing) * 8)}.px-9{padding-inline:calc(var(--spacing) * 9)}.px-10{padding-inline:calc(var(--spacing) * 10)}.px-11{padding-inline:calc(var(--spacing) * 11)}.px-12{padding-inline:calc(var(--spacing) * 12)}.px-14{padding-inline:calc(var(--spacing) * 14)}.px-16{padding-inline:calc(var(--spacing) * 16)}.px-20{padding-inline:calc(var(--spacing) * 20)}.px-24{padding-inline:calc(var(--spacing) * 24)}.px-28{padding-inline:calc(var(--spacing) * 28)}.px-32{padding-inline:calc(var(--spacing) * 32)}.px-36{padding-inline:calc(var(--spacing) * 36)}.px-40{padding-inline:calc(var(--spacing) * 40)}.px-44{padding-inline:calc(var(--spacing) * 44)}.px-48{padding-inline:calc(var(--spacing) * 48)}.px-52{padding-inline:calc(var(--spacing) * 52)}.px-56{padding-inline:calc(var(--spacing) * 56)}.px-60{padding-inline:calc(var(--spacing) * 60)}.px-64{padding-inline:calc(var(--spacing) * 64)}.px-72{padding-inline:calc(var(--spacing) * 72)}.px-80{padding-inline:calc(var(--spacing) * 80)}.px-96{padding-inline:calc(var(--spacing) * 96)}.py-0{padding-block:0}.py-0\\.5{padding-block:calc(var(--spacing) * .5)}.py-1{padding-block:var(--spacing)}.py-1\\.5{padding-block:calc(var(--spacing) * 1.5)}.py-2{padding-block:calc(var(--spacing) * 2)}.py-2\\.5{padding-block:calc(var(--spacing) * 2.5)}.py-3{padding-block:calc(var(--spacing) * 3)}.py-3\\.5{padding-block:calc(var(--spacing) * 3.5)}.py-4{padding-block:calc(var(--spacing) * 4)}.py-5{padding-block:calc(var(--spacing) * 5)}.py-6{padding-block:calc(var(--spacing) * 6)}.py-7{padding-block:calc(var(--spacing) * 7)}.py-8{padding-block:calc(var(--spacing) * 8)}.py-9{padding-block:calc(var(--spacing) * 9)}.py-10{padding-block:calc(var(--spacing) * 10)}.py-11{padding-block:calc(var(--spacing) * 11)}.py-12{padding-block:calc(var(--spacing) * 12)}.py-14{padding-block:calc(var(--spacing) * 14)}.py-16{padding-block:calc(var(--spacing) * 16)}.py-20{padding-block:calc(var(--spacing) * 20)}.py-24{padding-block:calc(var(--spacing) * 24)}.py-28{padding-block:calc(var(--spacing) * 28)}.py-32{padding-block:calc(var(--spacing) * 32)}.py-36{padding-block:calc(var(--spacing) * 36)}.py-40{padding-block:calc(var(--spacing) * 40)}.py-44{padding-block:calc(var(--spacing) * 44)}.py-48{padding-block:calc(var(--spacing) * 48)}.py-52{padding-block:calc(var(--spacing) * 52)}.py-56{padding-block:calc(var(--spacing) * 56)}.py-60{padding-block:calc(var(--spacing) * 60)}.py-64{padding-block:calc(var(--spacing) * 64)}.py-72{padding-block:calc(var(--spacing) * 72)}.py-80{padding-block:calc(var(--spacing) * 80)}.py-96{padding-block:calc(var(--spacing) * 96)}.pt-0{padding-top:0}.pt-0\\.5{padding-top:calc(var(--spacing) * .5)}.pt-1{padding-top:var(--spacing)}.pt-1\\.5{padding-top:calc(var(--spacing) * 1.5)}.pt-2{padding-top:calc(var(--spacing) * 2)}.pt-2\\.5{padding-top:calc(var(--spacing) * 2.5)}.pt-3{padding-top:calc(var(--spacing) * 3)}.pt-3\\.5{padding-top:calc(var(--spacing) * 3.5)}.pt-4{padding-top:calc(var(--spacing) * 4)}.pt-5{padding-top:calc(var(--spacing) * 5)}.pt-6{padding-top:calc(var(--spacing) * 6)}.pt-7{padding-top:calc(var(--spacing) * 7)}.pt-8{padding-top:calc(var(--spacing) * 8)}.pt-9{padding-top:calc(var(--spacing) * 9)}.pt-10{padding-top:calc(var(--spacing) * 10)}.pt-11{padding-top:calc(var(--spacing) * 11)}.pt-12{padding-top:calc(var(--spacing) * 12)}.pt-14{padding-top:calc(var(--spacing) * 14)}.pt-16{padding-top:calc(var(--spacing) * 16)}.pt-20{padding-top:calc(var(--spacing) * 20)}.pt-24{padding-top:calc(var(--spacing) * 24)}.pt-28{padding-top:calc(var(--spacing) * 28)}.pt-32{padding-top:calc(var(--spacing) * 32)}.pt-36{padding-top:calc(var(--spacing) * 36)}.pt-40{padding-top:calc(var(--spacing) * 40)}.pt-44{padding-top:calc(var(--spacing) * 44)}.pt-48{padding-top:calc(var(--spacing) * 48)}.pt-52{padding-top:calc(var(--spacing) * 52)}.pt-56{padding-top:calc(var(--spacing) * 56)}.pt-60{padding-top:calc(var(--spacing) * 60)}.pt-64{padding-top:calc(var(--spacing) * 64)}.pt-72{padding-top:calc(var(--spacing) * 72)}.pt-80{padding-top:calc(var(--spacing) * 80)}.pt-96{padding-top:calc(var(--spacing) * 96)}.pr-0{padding-right:0}.pr-0\\.5{padding-right:calc(var(--spacing) * .5)}.pr-1{padding-right:var(--spacing)}.pr-1\\.5{padding-right:calc(var(--spacing) * 1.5)}.pr-2{padding-right:calc(var(--spacing) * 2)}.pr-2\\.5{padding-right:calc(var(--spacing) * 2.5)}.pr-3{padding-right:calc(var(--spacing) * 3)}.pr-3\\.5{padding-right:calc(var(--spacing) * 3.5)}.pr-4{padding-right:calc(var(--spacing) * 4)}.pr-5{padding-right:calc(var(--spacing) * 5)}.pr-6{padding-right:calc(var(--spacing) * 6)}.pr-7{padding-right:calc(var(--spacing) * 7)}.pr-8{padding-right:calc(var(--spacing) * 8)}.pr-9{padding-right:calc(var(--spacing) * 9)}.pr-10{padding-right:calc(var(--spacing) * 10)}.pr-11{padding-right:calc(var(--spacing) * 11)}.pr-12{padding-right:calc(var(--spacing) * 12)}.pr-14{padding-right:calc(var(--spacing) * 14)}.pr-16{padding-right:calc(var(--spacing) * 16)}.pr-20{padding-right:calc(var(--spacing) * 20)}.pr-24{padding-right:calc(var(--spacing) * 24)}.pr-28{padding-right:calc(var(--spacing) * 28)}.pr-32{padding-right:calc(var(--spacing) * 32)}.pr-36{padding-right:calc(var(--spacing) * 36)}.pr-40{padding-right:calc(var(--spacing) * 40)}.pr-44{padding-right:calc(var(--spacing) * 44)}.pr-48{padding-right:calc(var(--spacing) * 48)}.pr-52{padding-right:calc(var(--spacing) * 52)}.pr-56{padding-right:calc(var(--spacing) * 56)}.pr-60{padding-right:calc(var(--spacing) * 60)}.pr-64{padding-right:calc(var(--spacing) * 64)}.pr-72{padding-right:calc(var(--spacing) * 72)}.pr-80{padding-right:calc(var(--spacing) * 80)}.pr-96{padding-right:calc(var(--spacing) * 96)}.pb-0{padding-bottom:0}.pb-0\\.5{padding-bottom:calc(var(--spacing) * .5)}.pb-1{padding-bottom:var(--spacing)}.pb-1\\.5{padding-bottom:calc(var(--spacing) * 1.5)}.pb-2{padding-bottom:calc(var(--spacing) * 2)}.pb-2\\.5{padding-bottom:calc(var(--spacing) * 2.5)}.pb-3{padding-bottom:calc(var(--spacing) * 3)}.pb-3\\.5{padding-bottom:calc(var(--spacing) * 3.5)}.pb-4{padding-bottom:calc(var(--spacing) * 4)}.pb-5{padding-bottom:calc(var(--spacing) * 5)}.pb-6{padding-bottom:calc(var(--spacing) * 6)}.pb-7{padding-bottom:calc(var(--spacing) * 7)}.pb-8{padding-bottom:calc(var(--spacing) * 8)}.pb-9{padding-bottom:calc(var(--spacing) * 9)}.pb-10{padding-bottom:calc(var(--spacing) * 10)}.pb-11{padding-bottom:calc(var(--spacing) * 11)}.pb-12{padding-bottom:calc(var(--spacing) * 12)}.pb-14{padding-bottom:calc(var(--spacing) * 14)}.pb-16{padding-bottom:calc(var(--spacing) * 16)}.pb-20{padding-bottom:calc(var(--spacing) * 20)}.pb-24{padding-bottom:calc(var(--spacing) * 24)}.pb-28{padding-bottom:calc(var(--spacing) * 28)}.pb-32{padding-bottom:calc(var(--spacing) * 32)}.pb-36{padding-bottom:calc(var(--spacing) * 36)}.pb-40{padding-bottom:calc(var(--spacing) * 40)}.pb-44{padding-bottom:calc(var(--spacing) * 44)}.pb-48{padding-bottom:calc(var(--spacing) * 48)}.pb-52{padding-bottom:calc(var(--spacing) * 52)}.pb-56{padding-bottom:calc(var(--spacing) * 56)}.pb-60{padding-bottom:calc(var(--spacing) * 60)}.pb-64{padding-bottom:calc(var(--spacing) * 64)}.pb-72{padding-bottom:calc(var(--spacing) * 72)}.pb-80{padding-bottom:calc(var(--spacing) * 80)}.pb-96{padding-bottom:calc(var(--spacing) * 96)}.pl-0{padding-left:0}.pl-0\\.5{padding-left:calc(var(--spacing) * .5)}.pl-1{padding-left:var(--spacing)}.pl-1\\.5{padding-left:calc(var(--spacing) * 1.5)}.pl-2{padding-left:calc(var(--spacing) * 2)}.pl-2\\.5{padding-left:calc(var(--spacing) * 2.5)}.pl-3{padding-left:calc(var(--spacing) * 3)}.pl-3\\.5{padding-left:calc(var(--spacing) * 3.5)}.pl-4{padding-left:calc(var(--spacing) * 4)}.pl-5{padding-left:calc(var(--spacing) * 5)}.pl-6{padding-left:calc(var(--spacing) * 6)}.pl-7{padding-left:calc(var(--spacing) * 7)}.pl-8{padding-left:calc(var(--spacing) * 8)}.pl-9{padding-left:calc(var(--spacing) * 9)}.pl-10{padding-left:calc(var(--spacing) * 10)}.pl-11{padding-left:calc(var(--spacing) * 11)}.pl-12{padding-left:calc(var(--spacing) * 12)}.pl-14{padding-left:calc(var(--spacing) * 14)}.pl-16{padding-left:calc(var(--spacing) * 16)}.pl-20{padding-left:calc(var(--spacing) * 20)}.pl-24{padding-left:calc(var(--spacing) * 24)}.pl-28{padding-left:calc(var(--spacing) * 28)}.pl-32{padding-left:calc(var(--spacing) * 32)}.pl-36{padding-left:calc(var(--spacing) * 36)}.pl-40{padding-left:calc(var(--spacing) * 40)}.pl-44{padding-left:calc(var(--spacing) * 44)}.pl-48{padding-left:calc(var(--spacing) * 48)}.pl-52{padding-left:calc(var(--spacing) * 52)}.pl-56{padding-left:calc(var(--spacing) * 56)}.pl-60{padding-left:calc(var(--spacing) * 60)}.pl-64{padding-left:calc(var(--spacing) * 64)}.pl-72{padding-left:calc(var(--spacing) * 72)}.pl-80{padding-left:calc(var(--spacing) * 80)}.pl-96{padding-left:calc(var(--spacing) * 96)}.text-center{text-align:center}.text-left{text-align:left}.text-right{text-align:right}.text-balance{text-wrap:balance}.text-pretty{text-wrap:pretty}.break-words{overflow-wrap:break-word}.break-all{word-break:break-all}.whitespace-break-spaces{white-space:break-spaces}.whitespace-normal{white-space:normal}.whitespace-nowrap{white-space:nowrap}.whitespace-pre{white-space:pre}.whitespace-pre-line{white-space:pre-line}.whitespace-pre-wrap{white-space:pre-wrap}}';

/**
 * Every class the stylesheet defines, as an author writes it. The composition linter rejects a
 * `class` token that is neither in here nor defined by the composition's own CSS, which is what
 * turns a misremembered or arbitrary-value utility into a blocking error rather than a rule that
 * silently matches nothing.
 */
export const LAYOUT_CLASS_NAMES: readonly string[] = [
    'absolute',
    'aspect-auto',
    'aspect-square',
    'aspect-video',
    'auto-cols-auto',
    'auto-cols-fr',
    'auto-cols-max',
    'auto-cols-min',
    'auto-rows-auto',
    'auto-rows-fr',
    'auto-rows-max',
    'auto-rows-min',
    'basis-0',
    'basis-1/2',
    'basis-1/3',
    'basis-1/4',
    'basis-2/3',
    'basis-3/4',
    'basis-auto',
    'basis-full',
    'block',
    'bottom-0',
    'box-border',
    'box-content',
    'break-all',
    'break-words',
    'col-end-1',
    'col-end-10',
    'col-end-11',
    'col-end-12',
    'col-end-13',
    'col-end-2',
    'col-end-3',
    'col-end-4',
    'col-end-5',
    'col-end-6',
    'col-end-7',
    'col-end-8',
    'col-end-9',
    'col-end-auto',
    'col-span-1',
    'col-span-10',
    'col-span-11',
    'col-span-12',
    'col-span-2',
    'col-span-3',
    'col-span-4',
    'col-span-5',
    'col-span-6',
    'col-span-7',
    'col-span-8',
    'col-span-9',
    'col-span-full',
    'col-start-1',
    'col-start-10',
    'col-start-11',
    'col-start-12',
    'col-start-13',
    'col-start-2',
    'col-start-3',
    'col-start-4',
    'col-start-5',
    'col-start-6',
    'col-start-7',
    'col-start-8',
    'col-start-9',
    'col-start-auto',
    'content-around',
    'content-between',
    'content-center',
    'content-end',
    'content-evenly',
    'content-normal',
    'content-start',
    'content-stretch',
    'contents',
    'flex',
    'flex-1',
    'flex-auto',
    'flex-col',
    'flex-col-reverse',
    'flex-initial',
    'flex-none',
    'flex-nowrap',
    'flex-row',
    'flex-row-reverse',
    'flex-wrap',
    'flex-wrap-reverse',
    'gap-0',
    'gap-0.5',
    'gap-1',
    'gap-1.5',
    'gap-10',
    'gap-11',
    'gap-12',
    'gap-14',
    'gap-16',
    'gap-2',
    'gap-2.5',
    'gap-20',
    'gap-24',
    'gap-28',
    'gap-3',
    'gap-3.5',
    'gap-32',
    'gap-36',
    'gap-4',
    'gap-40',
    'gap-44',
    'gap-48',
    'gap-5',
    'gap-52',
    'gap-56',
    'gap-6',
    'gap-60',
    'gap-64',
    'gap-7',
    'gap-72',
    'gap-8',
    'gap-80',
    'gap-9',
    'gap-96',
    'gap-x-0',
    'gap-x-0.5',
    'gap-x-1',
    'gap-x-1.5',
    'gap-x-10',
    'gap-x-11',
    'gap-x-12',
    'gap-x-14',
    'gap-x-16',
    'gap-x-2',
    'gap-x-2.5',
    'gap-x-20',
    'gap-x-24',
    'gap-x-28',
    'gap-x-3',
    'gap-x-3.5',
    'gap-x-32',
    'gap-x-36',
    'gap-x-4',
    'gap-x-40',
    'gap-x-44',
    'gap-x-48',
    'gap-x-5',
    'gap-x-52',
    'gap-x-56',
    'gap-x-6',
    'gap-x-60',
    'gap-x-64',
    'gap-x-7',
    'gap-x-72',
    'gap-x-8',
    'gap-x-80',
    'gap-x-9',
    'gap-x-96',
    'gap-y-0',
    'gap-y-0.5',
    'gap-y-1',
    'gap-y-1.5',
    'gap-y-10',
    'gap-y-11',
    'gap-y-12',
    'gap-y-14',
    'gap-y-16',
    'gap-y-2',
    'gap-y-2.5',
    'gap-y-20',
    'gap-y-24',
    'gap-y-28',
    'gap-y-3',
    'gap-y-3.5',
    'gap-y-32',
    'gap-y-36',
    'gap-y-4',
    'gap-y-40',
    'gap-y-44',
    'gap-y-48',
    'gap-y-5',
    'gap-y-52',
    'gap-y-56',
    'gap-y-6',
    'gap-y-60',
    'gap-y-64',
    'gap-y-7',
    'gap-y-72',
    'gap-y-8',
    'gap-y-80',
    'gap-y-9',
    'gap-y-96',
    'grid',
    'grid-cols-1',
    'grid-cols-10',
    'grid-cols-11',
    'grid-cols-12',
    'grid-cols-2',
    'grid-cols-3',
    'grid-cols-4',
    'grid-cols-5',
    'grid-cols-6',
    'grid-cols-7',
    'grid-cols-8',
    'grid-cols-9',
    'grid-cols-none',
    'grid-flow-col',
    'grid-flow-col-dense',
    'grid-flow-dense',
    'grid-flow-row',
    'grid-flow-row-dense',
    'grid-rows-1',
    'grid-rows-2',
    'grid-rows-3',
    'grid-rows-4',
    'grid-rows-5',
    'grid-rows-6',
    'grid-rows-none',
    'grow',
    'grow-0',
    'h-0',
    'h-1',
    'h-1/2',
    'h-10',
    'h-12',
    'h-16',
    'h-2',
    'h-20',
    'h-24',
    'h-28',
    'h-3',
    'h-32',
    'h-36',
    'h-4',
    'h-40',
    'h-44',
    'h-48',
    'h-5',
    'h-56',
    'h-6',
    'h-64',
    'h-72',
    'h-8',
    'h-80',
    'h-96',
    'h-auto',
    'h-fit',
    'h-full',
    'h-max',
    'h-min',
    'h-px',
    'h-screen',
    'hidden',
    'inline',
    'inline-block',
    'inline-flex',
    'inline-grid',
    'inset-0',
    'inset-x-0',
    'inset-y-0',
    'items-baseline',
    'items-center',
    'items-end',
    'items-start',
    'items-stretch',
    'justify-around',
    'justify-between',
    'justify-center',
    'justify-end',
    'justify-evenly',
    'justify-items-center',
    'justify-items-end',
    'justify-items-start',
    'justify-items-stretch',
    'justify-self-auto',
    'justify-self-center',
    'justify-self-end',
    'justify-self-start',
    'justify-self-stretch',
    'justify-start',
    'justify-stretch',
    'left-0',
    'm-0',
    'm-0.5',
    'm-1',
    'm-1.5',
    'm-10',
    'm-11',
    'm-12',
    'm-14',
    'm-16',
    'm-2',
    'm-2.5',
    'm-20',
    'm-24',
    'm-28',
    'm-3',
    'm-3.5',
    'm-32',
    'm-36',
    'm-4',
    'm-40',
    'm-44',
    'm-48',
    'm-5',
    'm-52',
    'm-56',
    'm-6',
    'm-60',
    'm-64',
    'm-7',
    'm-72',
    'm-8',
    'm-80',
    'm-9',
    'm-96',
    'm-auto',
    'max-h-full',
    'max-w-2xl',
    'max-w-3xl',
    'max-w-4xl',
    'max-w-5xl',
    'max-w-6xl',
    'max-w-7xl',
    'max-w-fit',
    'max-w-full',
    'max-w-lg',
    'max-w-max',
    'max-w-md',
    'max-w-min',
    'max-w-none',
    'max-w-sm',
    'max-w-xl',
    'max-w-xs',
    'mb-0',
    'mb-0.5',
    'mb-1',
    'mb-1.5',
    'mb-10',
    'mb-11',
    'mb-12',
    'mb-14',
    'mb-16',
    'mb-2',
    'mb-2.5',
    'mb-20',
    'mb-24',
    'mb-28',
    'mb-3',
    'mb-3.5',
    'mb-32',
    'mb-36',
    'mb-4',
    'mb-40',
    'mb-44',
    'mb-48',
    'mb-5',
    'mb-52',
    'mb-56',
    'mb-6',
    'mb-60',
    'mb-64',
    'mb-7',
    'mb-72',
    'mb-8',
    'mb-80',
    'mb-9',
    'mb-96',
    'mb-auto',
    'min-h-0',
    'min-h-full',
    'min-w-0',
    'min-w-full',
    'ml-0',
    'ml-0.5',
    'ml-1',
    'ml-1.5',
    'ml-10',
    'ml-11',
    'ml-12',
    'ml-14',
    'ml-16',
    'ml-2',
    'ml-2.5',
    'ml-20',
    'ml-24',
    'ml-28',
    'ml-3',
    'ml-3.5',
    'ml-32',
    'ml-36',
    'ml-4',
    'ml-40',
    'ml-44',
    'ml-48',
    'ml-5',
    'ml-52',
    'ml-56',
    'ml-6',
    'ml-60',
    'ml-64',
    'ml-7',
    'ml-72',
    'ml-8',
    'ml-80',
    'ml-9',
    'ml-96',
    'ml-auto',
    'mr-0',
    'mr-0.5',
    'mr-1',
    'mr-1.5',
    'mr-10',
    'mr-11',
    'mr-12',
    'mr-14',
    'mr-16',
    'mr-2',
    'mr-2.5',
    'mr-20',
    'mr-24',
    'mr-28',
    'mr-3',
    'mr-3.5',
    'mr-32',
    'mr-36',
    'mr-4',
    'mr-40',
    'mr-44',
    'mr-48',
    'mr-5',
    'mr-52',
    'mr-56',
    'mr-6',
    'mr-60',
    'mr-64',
    'mr-7',
    'mr-72',
    'mr-8',
    'mr-80',
    'mr-9',
    'mr-96',
    'mr-auto',
    'mt-0',
    'mt-0.5',
    'mt-1',
    'mt-1.5',
    'mt-10',
    'mt-11',
    'mt-12',
    'mt-14',
    'mt-16',
    'mt-2',
    'mt-2.5',
    'mt-20',
    'mt-24',
    'mt-28',
    'mt-3',
    'mt-3.5',
    'mt-32',
    'mt-36',
    'mt-4',
    'mt-40',
    'mt-44',
    'mt-48',
    'mt-5',
    'mt-52',
    'mt-56',
    'mt-6',
    'mt-60',
    'mt-64',
    'mt-7',
    'mt-72',
    'mt-8',
    'mt-80',
    'mt-9',
    'mt-96',
    'mt-auto',
    'mx-0',
    'mx-0.5',
    'mx-1',
    'mx-1.5',
    'mx-10',
    'mx-11',
    'mx-12',
    'mx-14',
    'mx-16',
    'mx-2',
    'mx-2.5',
    'mx-20',
    'mx-24',
    'mx-28',
    'mx-3',
    'mx-3.5',
    'mx-32',
    'mx-36',
    'mx-4',
    'mx-40',
    'mx-44',
    'mx-48',
    'mx-5',
    'mx-52',
    'mx-56',
    'mx-6',
    'mx-60',
    'mx-64',
    'mx-7',
    'mx-72',
    'mx-8',
    'mx-80',
    'mx-9',
    'mx-96',
    'mx-auto',
    'my-0',
    'my-0.5',
    'my-1',
    'my-1.5',
    'my-10',
    'my-11',
    'my-12',
    'my-14',
    'my-16',
    'my-2',
    'my-2.5',
    'my-20',
    'my-24',
    'my-28',
    'my-3',
    'my-3.5',
    'my-32',
    'my-36',
    'my-4',
    'my-40',
    'my-44',
    'my-48',
    'my-5',
    'my-52',
    'my-56',
    'my-6',
    'my-60',
    'my-64',
    'my-7',
    'my-72',
    'my-8',
    'my-80',
    'my-9',
    'my-96',
    'my-auto',
    'object-bottom',
    'object-center',
    'object-contain',
    'object-cover',
    'object-fill',
    'object-left',
    'object-none',
    'object-right',
    'object-scale-down',
    'object-top',
    'order-1',
    'order-10',
    'order-11',
    'order-12',
    'order-2',
    'order-3',
    'order-4',
    'order-5',
    'order-6',
    'order-7',
    'order-8',
    'order-9',
    'order-first',
    'order-last',
    'order-none',
    'overflow-auto',
    'overflow-clip',
    'overflow-hidden',
    'overflow-visible',
    'overflow-x-auto',
    'overflow-x-clip',
    'overflow-x-hidden',
    'overflow-x-visible',
    'overflow-y-auto',
    'overflow-y-clip',
    'overflow-y-hidden',
    'overflow-y-visible',
    'p-0',
    'p-0.5',
    'p-1',
    'p-1.5',
    'p-10',
    'p-11',
    'p-12',
    'p-14',
    'p-16',
    'p-2',
    'p-2.5',
    'p-20',
    'p-24',
    'p-28',
    'p-3',
    'p-3.5',
    'p-32',
    'p-36',
    'p-4',
    'p-40',
    'p-44',
    'p-48',
    'p-5',
    'p-52',
    'p-56',
    'p-6',
    'p-60',
    'p-64',
    'p-7',
    'p-72',
    'p-8',
    'p-80',
    'p-9',
    'p-96',
    'pb-0',
    'pb-0.5',
    'pb-1',
    'pb-1.5',
    'pb-10',
    'pb-11',
    'pb-12',
    'pb-14',
    'pb-16',
    'pb-2',
    'pb-2.5',
    'pb-20',
    'pb-24',
    'pb-28',
    'pb-3',
    'pb-3.5',
    'pb-32',
    'pb-36',
    'pb-4',
    'pb-40',
    'pb-44',
    'pb-48',
    'pb-5',
    'pb-52',
    'pb-56',
    'pb-6',
    'pb-60',
    'pb-64',
    'pb-7',
    'pb-72',
    'pb-8',
    'pb-80',
    'pb-9',
    'pb-96',
    'pl-0',
    'pl-0.5',
    'pl-1',
    'pl-1.5',
    'pl-10',
    'pl-11',
    'pl-12',
    'pl-14',
    'pl-16',
    'pl-2',
    'pl-2.5',
    'pl-20',
    'pl-24',
    'pl-28',
    'pl-3',
    'pl-3.5',
    'pl-32',
    'pl-36',
    'pl-4',
    'pl-40',
    'pl-44',
    'pl-48',
    'pl-5',
    'pl-52',
    'pl-56',
    'pl-6',
    'pl-60',
    'pl-64',
    'pl-7',
    'pl-72',
    'pl-8',
    'pl-80',
    'pl-9',
    'pl-96',
    'place-content-center',
    'place-content-end',
    'place-content-start',
    'place-content-stretch',
    'place-items-center',
    'place-items-end',
    'place-items-start',
    'place-items-stretch',
    'place-self-center',
    'place-self-end',
    'place-self-start',
    'place-self-stretch',
    'pr-0',
    'pr-0.5',
    'pr-1',
    'pr-1.5',
    'pr-10',
    'pr-11',
    'pr-12',
    'pr-14',
    'pr-16',
    'pr-2',
    'pr-2.5',
    'pr-20',
    'pr-24',
    'pr-28',
    'pr-3',
    'pr-3.5',
    'pr-32',
    'pr-36',
    'pr-4',
    'pr-40',
    'pr-44',
    'pr-48',
    'pr-5',
    'pr-52',
    'pr-56',
    'pr-6',
    'pr-60',
    'pr-64',
    'pr-7',
    'pr-72',
    'pr-8',
    'pr-80',
    'pr-9',
    'pr-96',
    'pt-0',
    'pt-0.5',
    'pt-1',
    'pt-1.5',
    'pt-10',
    'pt-11',
    'pt-12',
    'pt-14',
    'pt-16',
    'pt-2',
    'pt-2.5',
    'pt-20',
    'pt-24',
    'pt-28',
    'pt-3',
    'pt-3.5',
    'pt-32',
    'pt-36',
    'pt-4',
    'pt-40',
    'pt-44',
    'pt-48',
    'pt-5',
    'pt-52',
    'pt-56',
    'pt-6',
    'pt-60',
    'pt-64',
    'pt-7',
    'pt-72',
    'pt-8',
    'pt-80',
    'pt-9',
    'pt-96',
    'px-0',
    'px-0.5',
    'px-1',
    'px-1.5',
    'px-10',
    'px-11',
    'px-12',
    'px-14',
    'px-16',
    'px-2',
    'px-2.5',
    'px-20',
    'px-24',
    'px-28',
    'px-3',
    'px-3.5',
    'px-32',
    'px-36',
    'px-4',
    'px-40',
    'px-44',
    'px-48',
    'px-5',
    'px-52',
    'px-56',
    'px-6',
    'px-60',
    'px-64',
    'px-7',
    'px-72',
    'px-8',
    'px-80',
    'px-9',
    'px-96',
    'py-0',
    'py-0.5',
    'py-1',
    'py-1.5',
    'py-10',
    'py-11',
    'py-12',
    'py-14',
    'py-16',
    'py-2',
    'py-2.5',
    'py-20',
    'py-24',
    'py-28',
    'py-3',
    'py-3.5',
    'py-32',
    'py-36',
    'py-4',
    'py-40',
    'py-44',
    'py-48',
    'py-5',
    'py-52',
    'py-56',
    'py-6',
    'py-60',
    'py-64',
    'py-7',
    'py-72',
    'py-8',
    'py-80',
    'py-9',
    'py-96',
    'relative',
    'right-0',
    'row-end-1',
    'row-end-10',
    'row-end-11',
    'row-end-12',
    'row-end-13',
    'row-end-2',
    'row-end-3',
    'row-end-4',
    'row-end-5',
    'row-end-6',
    'row-end-7',
    'row-end-8',
    'row-end-9',
    'row-end-auto',
    'row-span-1',
    'row-span-10',
    'row-span-11',
    'row-span-12',
    'row-span-2',
    'row-span-3',
    'row-span-4',
    'row-span-5',
    'row-span-6',
    'row-span-7',
    'row-span-8',
    'row-span-9',
    'row-span-full',
    'row-start-1',
    'row-start-10',
    'row-start-11',
    'row-start-12',
    'row-start-13',
    'row-start-2',
    'row-start-3',
    'row-start-4',
    'row-start-5',
    'row-start-6',
    'row-start-7',
    'row-start-8',
    'row-start-9',
    'row-start-auto',
    'self-auto',
    'self-baseline',
    'self-center',
    'self-end',
    'self-start',
    'self-stretch',
    'shrink',
    'shrink-0',
    'size-full',
    'static',
    'text-balance',
    'text-center',
    'text-left',
    'text-pretty',
    'text-right',
    'top-0',
    'truncate',
    'w-0',
    'w-1',
    'w-1/12',
    'w-1/2',
    'w-10',
    'w-10/12',
    'w-11/12',
    'w-12',
    'w-16',
    'w-2',
    'w-2/12',
    'w-20',
    'w-24',
    'w-28',
    'w-3',
    'w-3/12',
    'w-32',
    'w-36',
    'w-4',
    'w-4/12',
    'w-40',
    'w-44',
    'w-48',
    'w-5',
    'w-5/12',
    'w-56',
    'w-6',
    'w-6/12',
    'w-64',
    'w-7/12',
    'w-72',
    'w-8',
    'w-8/12',
    'w-80',
    'w-9/12',
    'w-96',
    'w-auto',
    'w-fit',
    'w-full',
    'w-max',
    'w-min',
    'w-px',
    'w-screen',
    'whitespace-break-spaces',
    'whitespace-normal',
    'whitespace-nowrap',
    'whitespace-pre',
    'whitespace-pre-line',
    'whitespace-pre-wrap',
    'z-0',
    'z-10',
    'z-20',
    'z-30',
    'z-40',
    'z-50',
];
